export default __webpack_public_path__ + "static/media/24-MaryPop.80818295.jpg";